<template>
  <div class="container-component" id="container">
    <div class="row">
      <div class="sub-title">
        <span>{{ name }}</span>
        <span v-if="required" class="star">*</span>
      </div>
      <div class="container-content" v-if="list.length > 0">
        <div
          :class="fartherActiveIndex === `${fartherIndex}-${index}`?'component-container-active component-container':'component-container'"
          v-for="(item, index) in list"
          :key="index"
          @click.stop="selectComponent(item, `${fartherIndex}-${index}`)"
        >
          <div :class="fartherActiveIndex === `${fartherIndex}-${index}`?'remove removeActive':'remove'" @click="remove(index)">x</div>
          <component
            :is="item.htmlContent"
            :name="item.name"
            :placeholder="item.placeholder"
            :required="item.required"
            :isSelect="item.isSelect"
          ></component>
        </div>
      </div>
      <div v-else class="nothing-container">
        可拖入多个控件（不包含容器控件）
      </div>
      <div class="cost-details">
        <span>
          +增加同行人员
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import TextComponent from "@/components/form-control/text.vue";
import DateRange from "@/components/form-control/date-range.vue";
import UploadComponent from "@/components/form-control/upload.vue";
import CostDetails from "@/components/form-control/cost-details.vue";
export default {
  components: {
    TextComponent,
    DateRange,
    UploadComponent,
    CostDetails,
  },
  props: {
    name: {
      type: String
    },
    /* 是否必填 */
    required: {
      type: Boolean,
      default: true
    },
    fartherIndex: {
      type: Number
    },
    fartherActiveIndex: {
    },
    list: {
      type: Array,
    }
  },

  data() {
    return {
    }
  },

  created() {
  },
  mounted() {
  },

  methods: {
    /* 选中组件 */
    selectComponent(row, index) {
      this.$bus.emit("isFatherActiveIndex", index, row);
    },

    /* 删除控件 */
    remove(index) {
      this.list.splice(index,1)
    },
  }
}
</script>

<style lang='scss'>
</style>
